
<script>import { Σ } from "../../common/clsx/index";
import { getContext } from "../../common/svelte/index";
export let key;
const selected = getContext("selected");
const state = {};

$: {
  state.style = Σ("el-menu-item", {
    "is-active": $selected === key
  });
}

const updateSelected = () => $selected = key;</script>


<li class={state.style} on:click={updateSelected}>
        <slot />
    </li>


<style>

</style>